<template>
  <div id="commodity-list">
    <div class="commodity-content">
      <div class="commodity-foreach" v-for="(item, index) of auctionList" :key="index" @click="linkToDetail(item)">
        <div class="commodity-content-title">
          <div>
            <img class="img1" src="@/assets/imgs/match/店铺@2x.png" alt="" />
            <span style="font-weight: bold;">{{ item.orgName }}</span>
            <img class="img2" src="@/assets/imgs/match/更多@2x.png" alt="" />
          </div>
          <div v-if="item.matchActivityStatus=='07'">撮合失败</div>
          <div v-if="item.matchActivityStatus=='06'">撮合成功</div>
        </div>

        <div style="display: flex">
          <div class="commodity-content-left">
            <!-- <img src="@/assets/imgs/match/矩形@2x.png" alt="" /> -->
            <img :src="item.image" alt="" />
            <div class="timing">
              <img src="@/assets/imgs/match/路径@2x.png" alt="" />
              <span class="count-down" v-if="activeTab== '01'">
                                <van-count-down :time="item.startTime-curTime" format="DD天HH:mm:ss" />
              </span>
              <span v-if="activeTab== '02'" class="count-down">
                                <van-count-down :time="item.endTime-curTime" format="DD天HH:mm:ss" />
              </span>
              <span v-if="activeTab== '03'" class="count-down">
                                <van-count-down :time="curTime-item.endTime" format="DD天HH:mm:ss" />
              </span>
            </div>
          </div>
          <div class="commodity-content-right">
            <div class="goods-name">
              <span class="count-down" v-if="activeTab== '01'">
                距开始
<!--                <van-count-down :time="item.startTime-curTime" format="DD天HH:mm:ss" />-->
              </span>
              <span v-if="activeTab== '02'" class="count-down">
                距结束
<!--                <van-count-down :time="item.endTime-curTime" format="DD天HH:mm:ss" />-->
              </span>
              <span v-if="activeTab== '03'" class="count-down">
                已结束
<!--                <van-count-down :time="curTime-item.endTime" format="DD天HH:mm:ss" />-->
              </span>
              <span style="font-weight: bold;">{{ item.productName }} {{ item.productSpec }}
                {{ item.productEnterpriseName }} {{ item.productLevel }}
              </span>
            </div>
            <div class="goods-num">
              <span>所属区域：{{ item.departName }}</span>
              &nbsp;&nbsp;
              <span>生产企业:：{{ item.productEnterpriseName }}</span>

            </div>
            <div class="goods-num">
              <span>仓库：{{item.storeName}}</span>
              &nbsp;&nbsp;
              <span>规格牌号:：{{item.productSpec}}</span>
            </div>
            <div class="goods-exTiem">
              <span>{{ item.startTime | dateFilter("time") }} 至
                {{ item.endTime | dateFilter("time") }}</span>
            </div>
            <!-- <div class="goods-look">
              <span>查看公告</span>
              <img class="img2" src="@/assets/imgs/match/更多@2x.png" alt="" />
            </div> -->
          </div>
        </div>

        <!--   <div class="content-top" @click="linkToDetail(item)">
          <div class="content-left">
            <img v-lazy="item.image" />
          </div>
          <div class="content-right" style="position:relative">
            <div class="content-title">
              <p>{{item.productName}} {{item.productSpec}} {{item.productEnterpriseName}} {{item.productLevel}}
              </p>
            </div>
            <div class="content-line">
              <div v-if="item.productLine == '02'" class="location">
                <img class="location-img" src="@/assets/imgs/location.png" />
                {{item.stationName}}
              </div>
            </div>
            <div class="content-line" style="position:absolute;bottom:5px">
              <div class="count-dowm-wrap">
                <div class="status" v-if="activeTab!='join'" :class="{'end-status':activeTab == '03'}">{{TabTextList[activeTab]}}</div>
                <div class="count-down" v-if="activeTab== '01'">
                  距开始
                  <van-count-down :time="item.startTime-curTime" format="DD天HH:mm:ss" />
                </div>
                <div v-if="activeTab== '02'" class="count-down">
                  距结束
                  <van-count-down :time="item.endTime-curTime" format="DD天HH:mm:ss" />
                </div>
                <div v-if="activeTab== '03'" class="count-down">
                  已结束
                  <van-count-down :time="curTime-item.endTime" format="DD天HH:mm:ss" />
                </div>
                <div v-if="item.status == '60'" class="count-down">{{item.finalEndTime| dateFilter('time')}} 结束</div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="content-bottom conent-position">
          <div class="bottom-ie">
            <div class="bottom-line">
              <div>
                <span class="label">所属区域:</span>
                <span>{{ item.departName }}</span>
              </div>
              <div>
                <span class="label">生产企业:</span>
                <span class="price">{{ item.productEnterpriseName }}</span>
              </div>
            </div>
            <div class="bottom-line">
              <div>
                <span class="label">仓库:</span>
                <span>{{item.storeName}}</span>
              </div>
              <div>
                <span class="label">规格牌号:</span>
                <span>{{item.productSpec}}</span>
              </div>
            </div>
            <div class="bottom-line">
              <div style="width:100%">
                <span>{{item.startTime | dateFilter('time')}} 至 {{item.endTime | dateFilter('time')}}</span>
              </div>
            </div>
          </div>
          <div class="img-wrap">
            <img v-if="item.buttonStatus.winner" class="bid-img" src="" />
            <img class="bid-img" v-if="item.matchActivityStatus=='07'" src="@/assets/math/icon-failed.png" />
            <img class="bid-img" v-if="item.matchActivityStatus=='06'" src="@/assets/math/icon-success.png" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { auctionImg } from "@/views/auction/auction-utils";
export default {
  name: "auctionList",
  props: ["auctionList","activeTab"],
  data() {
    return {
      auctionImg: auctionImg,
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
      TabTextList: {
          "01": "即将开始",
          "02": "正在进行",
          "03": "已结束",
        },
      selectEle: {
        auctionStatusList: [
          { name: "即将开始", key: "toBegin" },
          { name: "正在竞拍", key: "inProgress" },
          { name: "已结束", key: "completed" },
          { name: "我参与的", key: "myIntent" },
        ],
        auModeList: {
          10: "最低价成交",
          20: "出价成交",
        },
        dissussWayList: {
          10: "公开报价",
          20: "封闭报价",
        },
        statusTextList: {
          30: "即将开始",
          40: "正在进行",
          50: "已结束",
          60: "已结束",
        },

      },
    };
  },
  computed: {
    curTime() {
      return new Date().getTime();
    },
  },
  methods: {
    auctionLink () {
      this.$toast('请到电脑端参与现货');
    },
    // 详情
    linkToDetail(item) {
      this.$router.push(`/matchup-detail?Id=${item.matchActivityNo}&activeTab=${this.activeTab}`);
    },
    // 查看公告
    lookNotice(item) {
      this.$router.push(`/auction-notice?auId=${item.auId}`);
    },
  },
};
</script>

<style lang="stylus" scoped>
#commodity-list {
  .commodity-content {
    padding: 40px 32px;

    .commodity-foreach {
      font-size: 24px;
      padding: 38px 24px;
      display: flex;
      flex-direction: column;
      margin-bottom: 32px;
      background: #fff;
      border-radius: 16px;

      .commodity-content-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        div:nth-child(1) {
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 32px;
            color: #333333;
            margin: 0 6px;
          }

          .img1 {
            width: 32px;
            height: 32px;
            vertical-align: top;
          }

          .img2 {
            width: 24px;
            height: 24px;
            vertical-align: baseline;
          }
        }

        div:nth-child(2) {
          width: 128px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background: rgba(95, 132, 219, 0.1);
          border-radius: 4px 4px 4px 4px;
          border: 1px solid rgba(95, 132, 219, 0.5);
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #5F84DB;
        }
      }

      .commodity-content-left {
        > img {
          width: 176px;
          height: 176px;
          margin-bottom: 16px;
        }

        .timing {
          position: relative;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 23.38px;
            height: 40px;
          }

          span {
            margin-left: 4px;
            display: inline-block;
            width: 171px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(242, 39, 24, 0.06);
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #E0000C;
          }
        }
      }

      .commodity-content-right {
        margin-left: 20px;

        .goods-name {
          span:nth-child(1) {
            display: inline-block;
            width: 67px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #E0000C;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            margin-right: 10px;
          }

          span:nth-child(2) {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 28px;
            color: #333333;
            line-height: 33px;
          }
        }

        .goods-pice {
          margin-top: 36px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          line-height: 33px;

          span {
            color: #FF5500;

            p {
              display: inline-block;
              font-size: 34px;
            }
          }
        }

        .goods-num {
          margin-top: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #666666;
        }

        .goods-exTiem {
          margin-top: 8px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #666666;
        }

        .goods-look {
          margin-top: 16px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #333333;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      /* ---------------------------------------------------- */
      .conent-position {
        display: flex;
        justify-content: space-between;

        .img-wrap {
          padding: 5px 0 5px 8px;

          .bid-img {
            width: 122.47px;
            height: 122.47px;
          }
        }
      }

      .bottom-ie {
        width: 100%;
      }

      .content-bottom {
        .bottom-line {
          font-size: 24px;
          font-weight: 400;
          display: flex;
          justify-content: space-between;
          line-height: 45px;
          height: 45px;

          >div {
            width: 50%;
          }

          .label-strong {
            font-weight: bold;
            font-size: 26px;
          }

          .red {
            color: #E12020;
          }
        }

        .aprove-button {
          display: flex;
          padding: 20px;
          justify-content: space-around;

          .text-underline {
            color: #57a3f3;
            text-decoration: underline;
            width: 130px;
            height: 40px;
            line-height: 40px;
            margin-right: 30px;
          }

          /deep/ .van-button {
            width: 130px;
            height: 40px;
            line-height: 40px;
          }
        }

        .bottom-height {
          border-top: 1px solid #E3E3E3;
          display: flex;
          align-items: center;
          height: 80px;
        }
      }

      .content-line {
        font-size: 24px;
        font-weight: 400;
        display: flex;
        align-items: center;
        height: 44px;

        .tag {
          margin-right: 5px;
          width: 84px;
          height: 30px;
          background: #FFFFFF;
          border: 1px solid #E12020;
          opacity: 1;
          border-radius: 4px;
          font-size: 20px;
          line-height: 30px;
          color: #E12020;
          text-align: center;
        }

        .location {
          display: flex;
          align-items: center;

          .location-img {
            width: 16px;
            height: 20px;
            margin-right: 5px;
          }
        }

        .label {
          margin-right: 5px;
        }

        .line {
          margin: 0 5px;
        }

        .price {
          font-size: 40px;
          color: #E12020;
        }

        .red {
          color: #E12020;
        }

        .count-dowm-wrap {
          display: flex;
          width: 468px;
          height: 33px;
          background: #F3F3F3;
          opacity: 1;
          border-radius: 4px;

          .status {
            width: 108px;
            background: #E12020;
            border-radius: 4px 16px 16px 4px;
            line-height: 33px;
            color: #FFFFFF;
            text-align: center;
          }

          .end-status { // 已结束
            background: #828999;
          }

          .count-down {
            flex: 1;
            display: flex;
            /* justify-content: center; */
            align-items: center;
            line-height: 33px;
            color: #333333;
            text-align: center;
          }
        }
      }

      .content-top {
        display: flex;

        .content-left {
          height: 214px;

          img {
            width: 214px;
            height: 214px;
            border-radius: 10px;
          }
        }

        .content-right {
          height: 214px;
          padding-left: 20px;
          padding-bottom: 10px;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
          flex: 1;
          display: flex;
          flex-direction: column;

          span {
            font-weight: 300;
            color: rgba(153, 153, 153, 1);
          }

          .content-title {
            font-size: 28px;
            font-weight: 400;
            display: flex;
            align-items: center;

            .circle-icon {
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              align-content: center;
              justify-content: center;
              border-radius: 50%;
              background: #E12020;
              color: #fff;
              margin-left: 10px;
              font-size: 20px;
            }

            .tag {
              margin-right: 5px;

              img {
                width: 26px;
                height: 30.86px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
